export const pagePathWithParams = (page) => {
  return `${page.path}${page.queryParams}`;
};
